/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GUFIds } from "./GUFIds";
import { GUFIdsFromJSON, GUFIdsFromJSONTyped, GUFIdsToJSON, GUFIdsToJSONTyped } from "./GUFIds";

/**
 *
 * @export
 * @interface ApiGufIdsList200Response
 */
export interface ApiGufIdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufIdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufIdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufIdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GUFIds>}
   * @memberof ApiGufIdsList200Response
   */
  results: Array<GUFIds>;
}

/**
 * Check if a given object implements the ApiGufIdsList200Response interface.
 */
export function instanceOfApiGufIdsList200Response(
  value: object
): value is ApiGufIdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufIdsList200ResponseFromJSON(json: any): ApiGufIdsList200Response {
  return ApiGufIdsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufIdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufIdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GUFIdsFromJSON),
  };
}

export function ApiGufIdsList200ResponseToJSON(json: any): ApiGufIdsList200Response {
  return ApiGufIdsList200ResponseToJSONTyped(json, false);
}

export function ApiGufIdsList200ResponseToJSONTyped(
  value?: ApiGufIdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GUFIdsToJSON),
  };
}
